import fetch from "isomorphic-fetch";
import _ from "lodash";
import { API2_URL, DIRECTORIES_REQUEST, DIRECTORIES_CONAGO_FETCH, DIRECTORIES_ACTORS_FETCH, DIRECTORIES_ACTORS_GROUPS_FETCH, DIRECTORIES_FAIL } from "../store/config";
import {newNotification} from "./notifications";
import {sessionService} from "redux-react-session";

export const conagoList = () => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				dispatch(directoriesRequest());

				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};

				return fetch(`${API2_URL}/directories/conago-clauses?per_page=all`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(conagoData(json)),
						error => {
							dispatch(newNotification({title:'¡Oh no!', content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: 'danger'}))
							return dispatch(directoriesFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					)
			})
	}
};

const conagoData = (json) => {
	return {
		type: DIRECTORIES_CONAGO_FETCH,
		isFetching: false,
		payload: json.data,
		timestamp: Date.now()
	}
};

export const actorsList = () => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				dispatch(directoriesRequest());

				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};

				return fetch(`${API2_URL}/directories/actors?per_page=all`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(actorsData(json)),
						error => {
							dispatch(newNotification({title:'¡Oh no!', content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: 'danger'}))
							return dispatch(directoriesFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					)
			})
	}
};

const actorsData = (json) => {
	return {
		type: DIRECTORIES_ACTORS_FETCH,
		isFetching: false,
		payload: json.data,
		timestamp: Date.now()
	}
};

export const actorsGroups = () => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				dispatch(directoriesRequest());

				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};

				return fetch(`${API2_URL}/directories/actors/groups?per_page=all`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(actorsGroupsData(json)),
						error => {
							dispatch(newNotification({title:'¡Oh no!', content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: 'danger'}))
							return dispatch(directoriesFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					)
			})
	}
};

const actorsGroupsData = (json) => {
	return {
		type: DIRECTORIES_ACTORS_GROUPS_FETCH,
		isFetching: false,
		payload: json.data,
		timestamp: Date.now()
	}
};

const directoriesRequest = () => {
	return {
		type: DIRECTORIES_REQUEST,
		isFetching: true,
		timestamp: Date.now()
	}
};

const directoriesFail = (error) => {
	return {
		type:DIRECTORIES_FAIL,
		isFetching: false,
		error: error,
		timestamp: Date.now()
	}
};


// WEBPACK FOOTER //
// ./src/actions/directories.jsx